import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

interface PropertyImageProps {
  photoPath: string | undefined;
}

const basePath = "https://cf.bstatic.com/"

export const PropertyImage: React.FC<PropertyImageProps> = ({
  photoPath,
}) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="w-full h-full flex justify-center bg-[#e9ecef]">
      {photoPath && !imageError ? (
        <img
          src={basePath + photoPath}
          alt=""
          className="object-cover rounded-md"
          onError={(e) => {
            console.error(e);

            setImageError(true)
          }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <ImageOff className="text-gray-400" />
        </div>
      )}
    </div>
  );
};